$(document).ready(function () {

  $(".gallery").each(function(){
    $(this).find(".gallery-item a").attr("data-fancybox",$(this).attr("id"));
  });

  var fancyboxDefaults = {
    padding: 8,
    loop: false,
    helpers: {
      overlay: {
        css: {
          'background': 'rgba(255,255,255,.8)'
        }
      }
    }
  };

  $(".fancybox, .gallery .gallery-item .gallery-icon a").fancybox(fancyboxDefaults);

  $(".text-block img").each(function(){
    //check if image has a link as a parent
    if($(this).parents(".gallery").length == 0 && $(this).parent("a").length == 1){
      var link = $(this).parent("a");
      //check if the links points to the image
      var urlParts = link.attr("href").split("/");
      var name = urlParts.pop().split(".");

      if($(this).attr("src").indexOf(name[0]) >= 0) {
        link.fancybox(fancyboxDefaults);
      }
    }
  });

// -------------------------- CONTACT FORM ------------------------------ //

  if ($("#contactForm").length) {
    $("#contactForm").submit(function (e) {
      //validation
      if ($(this).find("input[name='email']").val().length == 0) {
        $("#contactFormMessage").text("Vyplňte prosím e-mail");
        return false;
      }
      if ($(this).find("textarea[name='text']").val().length == 0) {
        $("#contactFormMessage").text("Vyplňte prosím text zprávy");
        return false;
      }

      e.preventDefault();
      var url = ajaxServiceURL + "/ajax/contact/website/" + $(this).data("websiteid");
      var params = $(this).serialize();
      params += "&url=" + document.URL;
      $.getJSON(url + '?' + params + "&callback=?", processDataContactForm);
    });
  }
});

function carousel() {

  //id odkazu/tlacitek jsou #js-gallery-prev resp. #js-gallery-next
  $("#js-gallery ul").carouFredSel({
    circular: false,
    infinite: false,
    auto: false,
    width: "100%",
    pagination: false,
    align: false,
    prev: {
      button: "#js-gallery-prev",
      key: "left"
    },
    next: {
      button: "#js-gallery-next",
      key: "right"
    },
    scroll: {
      onAfter: function (data) {
        $("#js-gallery-next.disabled, #js-gallery-prev.disabled").each(
          function () {
            $(this).fadeOut("Fast");
          }
        );
        $("#js-gallery-next, #js-gallery-prev").not(".disabled").each(
          function () {
            $(this).fadeIn("fast");
          }
        );
      }
    },
    onCreate: function () {
      $("#js-gallery-prev").hide(); //skryje tlacitko zpet po nacteni
    }
  });
}


